export default "https://cdn-static.gokick.com/assets/1efca0ef19d403b8805a53d90e225e0b5d561c25/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";